import { Navbar } from "@/components/Navbar";
import { Seo } from "@/components/Seo";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { VideoRacconto } from "@/components/VideoRacconto";
import { Manifesto } from "@/components/Manifesto";
import { Cronostoria } from "@/components/Cronostoria";
import { GalleriaPreview } from "@/components/GalleriaPreview";
import { Stampa } from "@/components/Stampa";
import { Contatti } from "@/components/Contatti";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Yuri Selvaggio — Manager e Business Broker internazionale"
        description="Yuri Selvaggio: manager e business broker tra Italia, Spagna e Albania. Recruiting sanitario, consulenza d'impresa e progetti innovativi da Yurax Project."
        path="/"
      />
      <Navbar />
      <Hero />
      <Marquee />
      <VideoRacconto />
      <Manifesto />
      <Cronostoria />
      <GalleriaPreview />
      <Stampa />
      <Contatti />
      <Footer />
    </main>
  );
}
